<script>
    import Icon from '@iconify/svelte';
    import issueReopened16 from '@iconify/icons-octicon/issue-reopened-16';
    import { getName, LogOut, checkCookie, setCookie, getCookie } from '../utils/utils.js';
    var name = "";
    name = getName() || "Test";
    var user_id = 1 // This is failsafe if no user is found
    var reducer_jobs = []
    if( checkCookie('access.6bgdz9n7') ) {
        const accessToken = getCookie('access.6bgdz9n7')
        const payload = accessToken.split('.')[1]
        const jstring = atob(payload)//.toString('base64') //TODO: change deprecated  function
        const obj = JSON.parse(jstring)
        user_id = obj.userId
        console.log("User id is "+user_id)
        
    }
    $: console.log('User id is ' + user_id);
    
    export let selected_reducer = "";
    $: console.log('Selected reducer is ' + selected_reducer);

    async function checkList1(user_id) {
		  let res = await fetch(
          "/api/user/list1/"+user_id, 
          {
              method: 'GET', // *GET, POST, PUT, DELETE, etc.
              mode: 'same-origin', // no-cors, *cors, same-origin
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              credentials: 'same-origin', // include, *same-origin, omit
              headers: {
                  'Authorization': `Bearer ${getCookie("access.6bgdz9n7")}`,
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
              // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: 'follow', // manual, *follow, error
              referrerPolicy: 'no-referrer' // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
               // no body in GET
          }
      );
      reducer_jobs = await res.json()
      console.log("Reducer jobs: " + reducer_jobs)
      return reducer_jobs;
        
        
	  }


    
    let promise = checkList1(user_id)
    let refreshtimeout;
    export function refresh() {
      refreshtimeout = setTimeout(function(){ promise = checkList1(user_id) }, 1000);
	  }

    async function computeReducer(id) {
      let res = await fetch(
          "/api/reducer/compute/"+id, 
          {
              method: 'PUT', // *GET, POST, PUT, DELETE, etc.
              mode: 'same-origin', // no-cors, *cors, same-origin
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              credentials: 'same-origin', // include, *same-origin, omit
              headers: {
                  'Authorization': `Bearer ${getCookie("access.6bgdz9n7")}`,
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
              // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: 'follow', // manual, *follow, error
              referrerPolicy: 'no-referrer' // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
               // no body in GET
          }
        );
        res.json()
        .then( retrieved_data => {console.log("computeReducer PUT: "+retrieved_data)})
        .then(refresh)
        return true;
    }

    async function quoteReducer(id) {
      let res = await fetch(
          "/api/reducer/quote/"+id, 
          {
              method: 'PUT', // *GET, POST, PUT, DELETE, etc.
              mode: 'same-origin', // no-cors, *cors, same-origin
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              credentials: 'same-origin', // include, *same-origin, omit
              headers: {
                  'Authorization': `Bearer ${getCookie("access.6bgdz9n7")}`,
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
              // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: 'follow', // manual, *follow, error
              referrerPolicy: 'no-referrer' // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
               // no body in GET
          }
        );
        res.json()
        .then(retrieved_data => {console.log("quoteReducer PUT: "+retrieved_data)} )
        .then(refresh)
        return true;
    }

    async function modifyReducer(id) {
      alert("Reducer job " + id +" can not be modified in this version. Please create new reducer or contact info@radeger.com for the upgrade.")
    }

    async function viewReducer(id) {
      selected_reducer = id
      console.log("Clicked on view. id=",id)
    }

    async function contactAdmin(id) {
      alert("Please contact info@radeger.com")
    }

    async function duplicateReducer(id) {
      alert("Reducer job " + id +" can not be duplicated in this version. Please create new reducer or contact info@radeger.com for the upgrade.")
    }

    async function archiveReducer(id) {
      let res = await fetch(
          "/api/reducer/archive/"+id, 
          {
              method: 'PUT', // *GET, POST, PUT, DELETE, etc.
              mode: 'same-origin', // no-cors, *cors, same-origin
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              credentials: 'same-origin', // include, *same-origin, omit
              headers: {
                  'Authorization': `Bearer ${getCookie("access.6bgdz9n7")}`,
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
              // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: 'follow', // manual, *follow, error
              referrerPolicy: 'no-referrer' // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
               // no body in GET
          }
        );
        res.json()
        .then(retrieved_data => {console.log("archiveReducer PUT: "+retrieved_data)})
        .then(refresh)
        return true;
    }

</script>

<div class="jobs_list">
  <div>List of recent reducer computations <button on:click={ refresh }>Refresh <Icon icon={issueReopened16} inline={true} /></button></div>
  <div class="header_line">
    
    <div style="float:left; width:3em">Id</div>
    <div style="float:left; width:7em">Created</div>
    <div style="float:left; width:4em">Status</div>
    <div style="float: right; width:14em">Handles</div>
  </div>

  <div class="list">
  {#await promise}
    <p>...waiting</p>
  {:then jobs}

    {#each jobs as job}

      {#if job["data"]["s"] != "archived"}

    
    <div>{job["data"]["j"].split(" ")[1]} </div>
    <div>{job["data"]["j"].split(" ")[0].split(".")[0].replace("T"," ").slice(0,-3)} </div>
    <div>{job["data"]["s"]}</div>

        {#if job["data"]["s"] == "created"}

    <div>
        <button on:click|once="{quoteReducer(job["ref"]["@ref"].id)}">Quote (1€)</button> 
        <button on:click|once="{modifyReducer(job["ref"]["@ref"].id)}">Modify</button>
        <!--<button on:click="{viewReducer(job["ref"]["@ref"].id)}">View</button>-->
        <button on:click|once="{archiveReducer(job["ref"]["@ref"].id)}">Archive</button>
    </div>

        {:else if job["data"]["s"] == "quotation_pending"}

    <div>
      <a href="#app" class="blink" style="color:rgb(253, 101, 253); font-size: smaller;" on:click="{refresh(job["ref"]["@ref"].id)}">Please wait and refresh...</a> 
    </div> 


        {:else if job["data"]["s"] == "quoted"}

    <div>
        <button on:click|once="{computeReducer(job["ref"]["@ref"].id)}">Compute ({job["data"]["q"]}€)</button> 
        <button on:click|once="{archiveReducer(job["ref"]["@ref"].id)}">Archive</button>
        <!--<button on:click="{viewReducer(job["ref"]["@ref"].id)}">View</button>-->
    </div>
        {:else if job["data"]["s"] == "computation_pending"}

    <div>
      <a href="#app" class="blink" style="color:rgb(253, 101, 253); font-size: smaller;" on:click="{refresh(job["ref"]["@ref"].id)}">Please wait and refresh...</a> 
    </div> 

        {:else if job["data"]["s"] == "computation_started"}

    <div>
      <a href="#app" class="blink" style="color:rgb(253, 101, 253); font-size: smaller;" on:click="{refresh(job["ref"]["@ref"].id)}">Please wait and refresh...</a> 
    </div> 

        {:else if job["data"]["s"] == "computed"}

    <div>
      <button on:click|once="{archiveReducer(job["ref"]["@ref"].id)}">Archive</button>
      <button on:click="{viewReducer(job["ref"]["@ref"].id)}">View</button>
    </div> 

        {:else if job["data"]["s"] == "failed"}

    <div>
      <button on:click|once="{archiveReducer(job["ref"]["@ref"].id)}">Archive</button>
      <button on:click="{duplicateReducer(job["ref"]["@ref"].id)}">Copy to new </button>
    </div> 

        {/if}
      {/if}

    {/each}

  {:catch error}
    <p style="color: red">{error.message}</p>
  {/await}

  </div>
    
</div>


<style>

.jobs_list {
  display: grid;
  grid-template-rows: min-content min-content auto;
  background-color: yellowgreen;
  padding: 10px;
  text-align: center;
  overflow: hidden;
  margin: 0px;
  scrollbar-color: black gray;
  font-size: medium;
}
.header_line {
  display: inline-grid;
  font-size: 18px;
  grid-template-columns: auto auto auto auto;
}
.list { 
  display: inline-grid;
  grid-template-columns: auto auto auto auto;
  background-color: whitesmoke;
  overflow-y: scroll;
  padding: 0px;
  scrollbar-color: black gray;
}
.blink {
  animation: blinker 1s linear infinite;
}

</style>